// extracted by mini-css-extract-plugin
export var big = "header-module--big--b4fd3";
export var branding = "header-module--branding--69c35";
export var colLogo = "header-module--colLogo--e80ff";
export var colMenu = "header-module--colMenu--e9805";
export var colMenuCard = "header-module--colMenuCard--b0703";
export var colUtil = "header-module--colUtil--59857";
export var content = "header-module--content--5232f";
export var contentHeading = "header-module--contentHeading--e3aec";
export var dHide = "header-module--dHide--ba938";
export var description = "header-module--description--607d6";
export var featuredProductBorder = "header-module--featuredProductBorder--7d44f";
export var featuredProductWithoutBorder = "header-module--featuredProductWithoutBorder--f1bc9";
export var grid = "header-module--grid--7bbfb";
export var icon = "header-module--icon--e370a";
export var item = "header-module--item--f96b4";
export var link = "header-module--link--3f55a";
export var lite = "header-module--lite--f8e6f";
export var mHide = "header-module--mHide--4080f";
export var main = "header-module--main--56da4";
export var mainMenu = "header-module--mainMenu--6e78b";
export var mainMenuBlock = "header-module--mainMenuBlock--8da15";
export var megaMenu = "header-module--megaMenu--331e0";
export var menuToggle = "header-module--menuToggle--4bee3";
export var menuWrap = "header-module--menuWrap--1c50f";
export var mobileMenuCta = "header-module--mobileMenuCta--a2790";
export var news = "header-module--news--b58d7";
export var noBorder = "header-module--noBorder--9fd5f";
export var notificationBar = "header-module--notificationBar--58a19";
export var product = "header-module--product--24d7c";
export var productDescription = "header-module--productDescription--3f087";
export var resources = "header-module--resources--1abc8";
export var root = "header-module--root--4f83b";
export var sectionTitle = "header-module--sectionTitle--77cf7";
export var showcase = "header-module--showcase--d1267";
export var small = "header-module--small--f2765";
export var subMenu = "header-module--subMenu--81d34";
export var subMenuCard = "header-module--subMenuCard--f1b13";
export var text = "header-module--text--e8514";
export var textWrap = "header-module--textWrap--da189";
export var utilMenu = "header-module--utilMenu--c2e1a";
export var utilMenuBlock = "header-module--utilMenuBlock--8af04";